import AuthModule from './authentication'

export default (context, inject) => {
  const $auth = new AuthModule(context)

  inject('auth', $auth)
  context.$auth = $auth
}
